class PaginatenNext extends HTMLElement {
  static currentPage = 1;
  constructor() {
    super();
  }
  showAllItems(){
    const section = this.closest('.shopify-section');
    const children = section?.querySelectorAll("[pagination-parent] product-card[pagination-child]");
    children.forEach(child => {
      child.style.display = '';
    });
  }
  checkItemCount() {
    const section = this.closest('.shopify-section');
    const children = section?.querySelectorAll("[pagination-parent] product-card[pagination-child]");
    const paginateSize = Number(this.getAttribute("paginate-size"));
    const shouldSize = PaginatenNext.currentPage * paginateSize
    console.log('currentPage', PaginatenNext.currentPage);
    if(children.length < shouldSize){
      console.log('loading more items');
      const url = this.getAttribute("paginate-next");
      if (!!url) {
        this.updateDOM(url);
      }
    } else {
      console.log('enough items loaded');
      PaginatenNext.currentPage += 1;
    }
    children.forEach((child,index) => {
      if(index < shouldSize) {
        child.style.display = '';
      } else {
        child.style.display = 'none';
      }
    });
  }
  updateDOM(url) {
    const section = this.closest('.shopify-section');
    const loadingText = this.getAttribute("loading-text");
    this.innerHTML = `<span>${loadingText}</span>`;
    if (!!section) {
      section.classList.add("loading");
      this.classList.add("loading");
      const section_id = section.getAttribute('id').split('shopify-section-').pop();
      if (!!section_id && !!url) {
        const fetch_url = new URL(url, location.origin);
        fetch_url.searchParams.set("section_id", section_id);
        fetch(fetch_url.href, {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          method: "GET",
        })
          .then((response) => response.text())
          .then((data) => {
            const template = document.createElement("template");
            template.innerHTML = data.trim();
            const pagination_parent = section.querySelector("[pagination-parent]");
            const combinedListingDisplay = pagination_parent.dataset?.combinedListingDisplay
            if(!!pagination_parent){
              const old_pagination_children = pagination_parent.querySelectorAll("[pagination-child]");
              const new_pagination_children = template.content.querySelectorAll("[pagination-parent] [pagination-child]");
              const combined_listing_ids = Array.from(old_pagination_children).filter(child => !!child.getAttribute('combined-listing-id')).map(child => child.getAttribute('combined-listing-id'));
              for (const child of new_pagination_children) {
                const combined_listing_id = child.getAttribute('combined-listing-id');
                if(!!combined_listing_id && !combined_listing_ids.find(id => id == combined_listing_id) && combinedListingDisplay == 'parents'){
                  pagination_parent.append(child);
                  combined_listing_ids.push(combined_listing_id);
                }
                if(!combined_listing_id || combinedListingDisplay == 'childs') {
                  pagination_parent.append(child);
                }
              }
            }
            const old_pagination_element = this;
            const new_pagination_element = template.content.querySelector("paginate-next");
            if (!!new_pagination_element) {
              old_pagination_element.replaceWith(new_pagination_element);
            } else {
              this.showAllItems();
              old_pagination_element.remove();
            }
            this.classList.remove("loading");
            section.classList.remove("loading");
          })
          .catch(function (err) {
            console.error(err);
            this.classList.remove("loading");
            section.classList.remove("loading");
          });
      }
    }
  }
  connectedCallback() {
    this.checkItemCount();
    this.addEventListener("click", () => {
      const url = this.getAttribute("paginate-next");
      if (!!url) {
        this.updateDOM(url);
      }
    });
  }
}
customElements.define("paginate-next", PaginatenNext);